"use client";

import { ReactElement } from "react";
import type { PropsWithChildren } from "react";
import LazyLoadAfterTriggerWait from "./LazyLoadAfterTriggerWait";

type Trigger = "scroll" | "touch" | "click" | string;

interface LazyLoadAfterTriggerProps {
  lazy: "eager" | "lazy";
  triggers: Trigger[];
  autoTrigger?: boolean;
  selector?: string;
  dontLoadUntilEager?: boolean;
  ComponentLazyLoad?: ReactElement;
  triggerCallback?: (event: any, triggerShow: () => void) => void;
}

function LazyLoadAfterTrigger({
  lazy,
  children,
  selector,
  triggers,
  autoTrigger,
  dontLoadUntilEager = false,
  ComponentLazyLoad,
  triggerCallback,
}: PropsWithChildren<LazyLoadAfterTriggerProps>) {
  if (lazy === "eager") {
    return <>{children}</>;
  }

  return (
    <LazyLoadAfterTriggerWait
      lazy={lazy}
      triggers={triggers}
      autoTrigger={autoTrigger}
      selector={selector}
      dontLoadUntilEager={dontLoadUntilEager}
      ComponentLazyLoad={ComponentLazyLoad}
      triggerCallback={triggerCallback}
    >
      {children}
    </LazyLoadAfterTriggerWait>
  );
}

export default LazyLoadAfterTrigger;
